import { useCallback } from 'react'
import { authService } from '@oneblink/apps-react'
import { useAppConfig } from '../../providers/AppConfigProvider'

function LogInButton() {
  const { formsOAuthClientId } = useAppConfig()
  const signIn = useCallback(async () => {
    if (formsOAuthClientId) {
      await authService.loginHostedUI(formsOAuthClientId)
    }
  }, [formsOAuthClientId])

  return (
    <button className="button ob-button is-primary" onClick={signIn}>
      Log In
    </button>
  )
}

export default LogInButton
